import Vue from 'vue'
import '@/scss/main.scss'
import QuizComponent from '@/components/QuizComponent'
import QuizSlider from '@/components/QuizSlider'

Vue.config.productionTip = false
new Vue({
  el: '#app',
  components: {
    QuizComponent,
    QuizSlider
  },
  // render: h => h(QuizComponent),
});
